import { useEffect } from "react";
import { ControlledMenu, useMenuState } from "@szhsin/react-menu";
import { ReactComponent as Copy } from "../../../../../assets/images/fileManager/context/Copy.svg";
import { ReactComponent as Cut } from "../../../../../assets/images/fileManager/context/Cut.svg";
import { ReactComponent as Rename } from "../../../../../assets/images/fileManager/context/Rename.svg";
import { ReactComponent as Share } from "../../../../../assets/images/fileManager/context/Share.svg";
import { ReactComponent as Link } from "../../../../../assets/images/fileManager/context/Link.svg";
import { ReactComponent as Download } from "../../../../../assets/images/fileManager/context/Download.svg";
import { ReactComponent as Star } from "../../../../../assets/images/fileManager/context/Star.svg";
import { ReactComponent as StarSlash } from "../../../../../assets/images/fileManager/context/StarSlash.svg";
import { ReactComponent as Info } from "../../../../../assets/images/fileManager/context/Info.svg";
import { ReactComponent as Trash } from "../../../../../assets/images/fileManager/context/Trash.svg";
import { ReactComponent as NewFolder } from "../../../../../assets/images/fileManager/NewFolder.svg";
import { ReactComponent as FolderUpload } from "../../../../../assets/images/fileManager/FolderUpload.svg";
import { ReactComponent as FileUpload } from "../../../../../assets/images/fileManager/FileUpload.svg";
import { ReactComponent as LinkUpload } from "../../../../../assets/images/fileManager/LinkUpload.svg";
import { ReactComponent as Restore } from "../../../../../assets/images/fileManager/context/Restore.svg";
import { ReactComponent as Clock } from "../../../../../assets/images/fileManager/context/Clock.svg";
import { ReactComponent as Folder } from "../../../../../assets/images/fileManager/context/folder-2.svg";
import { ReactComponent as AddItem } from "../../../../../assets/images/fileManager/context/AddItem.svg";
import { ReactComponent as FileLink } from "../../../../../assets/images/fileManager/context/link-2.svg";
import { ReactComponent as PreviousBtn } from "../../../../../assets/images/fileManager/context/previous.svg";
import { ReactComponent as NextBtn } from "../../../../../assets/images/fileManager/context/next.svg";
import { ReactComponent as PrintBtn } from "../../../../../assets/images/fileManager/context/printer.svg";
import {
    handleDownloadTheResource,
    handleSetContextMenuStatus,
    handleSetCutModalStatus,
    handleSetDeleteConfirmationModalStatus,
    handleSetInformationModalStatus,
    handleSetLinkUploadModalStatus,
    handleSetNewFolderModalStatus,
    handleSetPublicLink,
    handleSetPublicLinkFolder,
    handleSetRenameModalStatus,
    handleSetShareModalStatus,
    handleSetTrashConfirmationModalStatus,
    handleSetUnshareConfimrationModalStatus,
    handleSetVersioningModalStatus
} from "../../fileManager.actions";
import { DeviceEnum } from "../../../../../redux/slices/environmentSlice";
import {
    addToFavoriteResources,
    copyResources,
    deleteFromFavoriteResources,
    restoreResources,
    syncFileManager,
    trashResources
} from "../../fileManager.function";
import ReactDOM from "react-dom";
import { ContextMenuProps } from "./contextMenu.interface";
import { handleSetShareCutModalStatus } from "../../sharedFileManager/sharedFileManager.actions";
import { zIndexs } from "../../../../../interfaces/environment";
import Dialog from "../../../dialog/dialog.index";
import { checkQuota, handleSetFileUploadState, handleSetFolderUploadState } from "../../../../../scripts/upload";
import { getPathHash } from "../../../../../scripts/helpers";
import PATH from "../../../../../urls/path";
import { useLocation, useNavigate } from "react-router-dom";
import { closeToast, toast } from "mobin-toast";
import { toastMessages } from "../../../../../scripts/toastMessages";
import { useAppSelector } from "../../../../../redux/hooks";
import { shallowEqual } from "react-redux";

export default function ContextMenu({ fileInput, folderInput, mode }: ContextMenuProps): JSX.Element {
    const { device } = useAppSelector(({ environment: { device } }) => ({ device }), shallowEqual);
    const { selectedResources, contextMenuStatus, versioningModalStatus, contextMenuPosition, contextMenuItems } = useAppSelector(
        ({
            fileManager: { selectedResources, filteredResources, contextMenuStatus, versioningModalStatus, contextMenuPosition, contextMenuItems }
        }) => ({
            selectedResources,
            filteredResources,
            contextMenuStatus,
            versioningModalStatus,
            contextMenuPosition,
            contextMenuItems
        }),
        shallowEqual
    );
    const [menuProps, toggleMenu] = useMenuState();
    const location = useLocation();
    const navigate = useNavigate();

    const blockRefresh = (e: any) => {
        e.preventDefault();
        e.returnValue = "";
        return "";
    };

    const fileManagerContextMenuItems = [
        {
            title: "پوشه جدید",
            key: "NEW_FOLDER",
            icon: <NewFolder className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetNewFolderModalStatus(true)
        },
        {
            title: "آپلود فایل",
            key: "FILE_UPLOAD",
            icon: <FileUpload className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => fileInput.current.click()
        },
        {
            title: "آپلود پوشه",
            key: "FOLDER_UPLOAD",
            icon: <FolderUpload className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => folderInput.current.click()
        },
        {
            title: "آپلود از طریق لینک",
            key: "LINK_UPLOAD",
            icon: <LinkUpload className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetLinkUploadModalStatus(true)
        },
        // {
        //     title: "ایجاد فایل اکسل جدید",
        //     key: "EXCEL_UPLOAD",
        //     icon: <AddItem className="fill-secondary-500" width="20px" height="20px" />,
        //     onClick: () => {
        //         const qs = new URLSearchParams(window.location.search);
        //         navigate(PATH.excelEditor(undefined, qs.get("path")!));
        //     }
        // },
        {
            title: "کپی در محل",
            key: "COPY",
            icon: <Copy className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => {
                if (contextMenuStatus) {
                    handleSetContextMenuStatus(false);
                    window.addEventListener("beforeunload", blockRefresh);
                    const isInShareFileManager = location.pathname === PATH.shared;
                    const promise = copyResources(mode, false, isInShareFileManager);
                    toast({ title: toastMessages(49), type: "promise", id: "copy" });
                    promise.then((data) => {
                        const temp: any = data;
                        closeToast("copy");
                        window.removeEventListener("beforeunload", blockRefresh);
                        if (temp.successCount === 0) {
                            toast({
                                title: toastMessages(50, [temp.quota, temp.isInShareFileManager]),
                                type: "error"
                            });
                        } else if (temp.successCount !== temp.count) {
                            toast({
                                title: toastMessages(51, [temp.successCount, temp.count, temp.quota, temp.isInShareFileManager]),
                                type: "warning"
                            });
                        } else {
                            toast({ title: toastMessages(52), type: "success" });
                        }
                    });
                }
            }
        },
        {
            title: "کپی در فایل‌های من",
            key: "COPY_MY_FILES",
            icon: <Copy className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => {
                window.addEventListener("beforeunload", blockRefresh);
                const promise = copyResources(mode, true);
                toast({ title: toastMessages(53), type: "promise", id: "copy" });
                promise.then((data) => {
                    closeToast("copy");
                    const temp: any = data;
                    window.removeEventListener("beforeunload", blockRefresh);
                    if (temp.successCount === 0) {
                        toast({ title: toastMessages(54, [temp.quota]), type: "error" });
                    } else if (temp.successCount !== temp.count) {
                        toast({
                            title: toastMessages(55, [temp.successCount, temp.count, temp.quota]),
                            type: "warning"
                        });
                    } else {
                        toast({ title: toastMessages(56), type: "success" });
                    }
                });
            }
        },
        {
            title: "انتقال به",
            key: "CUT",
            icon: <Cut className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetCutModalStatus(true)
        },
        {
            title: "انتقال به",
            key: "SHARED_CUT",
            icon: <Cut className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetShareCutModalStatus(true)
        },
        {
            title: "تغییر نام",
            key: "RENAME",
            icon: <Rename className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetRenameModalStatus(true)
        },
        {
            title: "اشتراک فایل",
            key: "SHARE",
            icon: <Share className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetShareModalStatus(true)
        },
        {
            title: "ایجاد لینک",
            key: "LINK",
            icon: <Link className="fill-secondary-500" width="20px" height="20px" />,
            onClick:
                selectedResources.length > 0 && selectedResources[0].folder_metadata === null
                    ? () => handleSetPublicLink(true)
                    : () => handleSetPublicLinkFolder(true)
        },
        {
            title: "دانلود",
            key: "DOWNLOAD",
            icon: <Download className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleDownloadResource()
        },
        {
            title: "مدیریت نسخه‌ها",
            key: "VERSION",
            icon: <Clock className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetVersioningModalStatus(true)
        },
        {
            title: "رفتن به مسیر",
            key: "FILE_PARENT",
            icon: <Folder className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleNavigateToParent()
        },
        {
            title: "افزودن به علاقه‌مندی‌ها",
            key: "FAVORITE",
            icon: <Star className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => addToFavoriteResources(mode)
        },
        {
            title: "حذف از علاقه‌مندی‌ها",
            key: "REMOVE_FAVORITE",
            icon: <StarSlash className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => deleteFromFavoriteResources(mode)
        },
        {
            title: "اطلاعات فایل",
            key: "INFORMATION",
            icon: <Info className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => handleSetInformationModalStatus(true)
        },
        {
            title: "مدیریت لینک‌ها",
            key: "FILE_LINKS",
            icon: <FileLink className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => {
                handleSetContextMenuStatus(false);
                navigate(PATH.links(selectedResources[0].id));
            }
        },
        {
            title: "حذف فایل",
            key: "TRASH",
            icon: <Trash className="fill-red-500" width="20px" height="20px" />,
            onClick: () => handleTrashResources()
        },
        {
            title: "حذف فایل",
            key: "UNSHARED",
            icon: <Trash className="fill-red-500" width="20px" height="20px" />,
            onClick: () => handleSetUnshareConfimrationModalStatus(true)
        },
        {
            title: "بازگردانی فایل",
            key: "RESTORE",
            icon: <Restore className="fill-secondary-500" width="20px" height="20px" />,
            onClick: () => {
                window.addEventListener("beforeunload", blockRefresh);
                const promise = restoreResources(mode);
                toast({ title: toastMessages(57), type: "promise", id: "restore" });
                promise.then((data) => {
                    const temp: any = data;
                    closeToast("restore");
                    window.removeEventListener("beforeunload", blockRefresh);
                    if (temp.successCount === 0) {
                        toast({ title: toastMessages(58), type: "error" });
                    } else if (temp.successCount !== temp.count) {
                        toast({
                            title: toastMessages(59, [temp.successCount, temp.count]),
                            type: "warning",
                            callbackFunction: () => {
                                const resources = temp.doneResources;
                                return new Promise((resolve) => {
                                    trashResources(resources).then(() => {
                                        resolve(true);
                                        syncFileManager();
                                    });
                                });
                            }
                        });
                    } else {
                        toast({
                            title: toastMessages(60),
                            type: "success",
                            callbackFunction: () => {
                                const resources = temp.doneResources;
                                return new Promise((resolve) => {
                                    trashResources(resources).then(() => {
                                        resolve(true);
                                        syncFileManager();
                                    });
                                });
                            }
                        });
                    }
                });
            }
        },
        {
            title: "حذف فایل برای همیشه",
            key: "DELETE",
            icon: <Trash className="fill-red-500" width="20px" height="20px" />,
            onClick: () => handleDeleteResources()
        },
        {
            title: "پرینت",
            key: "PRINT",
            icon: <PrintBtn className={`fill-secondary-500`} width="20px" height="20px" />,
            onClick: () => {
                document.getElementById("preview-print-button")?.click();
                handleSetContextMenuStatus(false);
            }
        },
        {
            title: "رفتن به فایل بعد",
            key: "NEXT_FILE",
            icon: <NextBtn className={`fill-secondary-500`} width="20px" height="20px" />,
            onClick: () => {
                document.getElementById("preview-next-btn")?.click();
                handleSetContextMenuStatus(false);
            }
        },
        {
            title: "رفتن به فایل قبل",
            key: "PREVIOUS_FILE",
            icon: <PreviousBtn className={`fill-secondary-500`} width="20px" height="20px" />,
            onClick: () => {
                document.getElementById("preview-previous-btn")?.click();
                handleSetContextMenuStatus(false);
            }
        },
        {
            title: "رفتن به فایل بعد",
            key: "DISABLE_NEXT_FILE",
            icon: <NextBtn className={`fill-secondary-500`} width="20px" height="20px" />,
            onClick: () => false
        },
        {
            title: "رفتن به فایل قبل",
            key: "DISABLE_PREVIOUS_FILE",
            icon: <PreviousBtn className={`fill-secondary-500`} width="20px" height="20px" />,
            onClick: () => false
        }
    ];

    useEffect(() => {
        toggleMenu(contextMenuStatus);
    }, [contextMenuStatus]);

    const onContextMenuClose = () => {
        toggleMenu(false);
        handleSetContextMenuStatus(false);
    };

    const handleDownloadResource = () => {
        handleDownloadTheResource();
        onContextMenuClose();
    };

    const handleTrashResources = () => {
        handleSetTrashConfirmationModalStatus(true);
        onContextMenuClose();
    };

    const handleDeleteResources = () => {
        handleSetDeleteConfirmationModalStatus(true);
        onContextMenuClose();
    };

    const handleNavigateToParent = () => {
        const selectedResource = selectedResources[0];
        const resourceParent = selectedResource.parent ? `${PATH.files}?path=${selectedResource.parent.toString()}` : PATH.files;
        handleSetContextMenuStatus(false);
        navigate(resourceParent);
    };

    return ReactDOM.createPortal(
        <section id="contextMenu">
            <input
                type="file"
                className="hidden upload-input"
                ref={fileInput}
                multiple={!versioningModalStatus}
                onChange={(e) => {
                    if (e.target.files) {
                        const files = Array.prototype.slice.call(e.target.files);
                        if (location.pathname !== PATH.shared) {
                            checkQuota(
                                files.reduce((sum, item) => sum + item.size, 0),
                                files
                            ).then((status) => {
                                if (status) {
                                    handleSetFileUploadState({
                                        files: files,
                                        hash: location.pathname === PATH.shared ? getPathHash() : undefined,
                                        versionGroup: versioningModalStatus ? selectedResources[0].version_group : undefined
                                    });
                                }
                            });
                        } else {
                            handleSetFileUploadState({
                                files: files,
                                hash: location.pathname === PATH.shared ? getPathHash() : undefined
                            });
                        }
                    }
                    handleSetContextMenuStatus(false);
                }}
            />
            <input
                type="file"
                className="hidden upload-input"
                ref={folderInput}
                multiple={true}
                // @ts-ignore
                directory="true"
                webkitdirectory="true"
                onChange={(e) => {
                    const files = Array.prototype.slice.call(e.target.files);
                    if (location.pathname !== PATH.shared) {
                        checkQuota(
                            files.reduce((sum, item) => sum + item.size, 0),
                            [],
                            files
                        ).then((status) => {
                            if (status) {
                                handleSetFolderUploadState({
                                    files: e.target.files as any,
                                    hash: location.pathname === PATH.shared ? getPathHash() : undefined
                                });
                            }
                        });
                    } else {
                        handleSetFolderUploadState({
                            files: e.target.files as any,
                            hash: location.pathname === PATH.shared ? getPathHash() : undefined
                        });
                        folderInput.current.value = "";
                    }
                    handleSetContextMenuStatus(false);
                }}
            />
            {device === DeviceEnum.desktop ? (
                <ControlledMenu
                    {...menuProps}
                    anchorPoint={contextMenuPosition}
                    onClose={onContextMenuClose}
                    menuStyle={{ zIndex: zIndexs.contextMenu }}
                    menuClassName={`!w-[220px] absolute bg-white !p-0 overflow-hidden !rounded-[5px] !drop-shadow-2xl !shadow-none !select-none`}
                >
                    <div>
                        {fileManagerContextMenuItems
                            .filter((item) => contextMenuItems.includes(item.key))
                            .filter((item) => (item.key === "NEXT_FILE" ? false : item.key === "PREVIOUS_FILE" ? false : true))
                            .map((item) => (
                                <div
                                    key={item.key}
                                    className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group"
                                    onClick={item.onClick}
                                >
                                    {item.icon}
                                    <span
                                        className={`text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all ${(item.key === "TRASH" || item.key === "DELETE" || item.key === "UNSHARED") && "!group-hover:text-red-500 !text-red-500"}`}
                                    >
                                        {item.title}
                                    </span>
                                </div>
                            ))}
                    </div>
                </ControlledMenu>
            ) : (
                <>
                    <Dialog
                        clearSelectedFiles={true}
                        closeOnBlur={true}
                        status={contextMenuStatus && selectedResources.length > 0}
                        onClose={() => handleSetContextMenuStatus(false)}
                        closeButton={false}
                    >
                        <div className="p-4">
                            {fileManagerContextMenuItems
                                .filter((item) => contextMenuItems.includes(item.key))
                                .map((item) => (
                                    <div
                                        key={item.key}
                                        className={`p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group ${item.key.startsWith("DISABLE") && "opacity-50"}`}
                                        onClick={item.onClick}
                                    >
                                        {item.icon}
                                        <span
                                            className={`text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all ${(item.key === "TRASH" || item.key === "DELETE" || item.key === "UNSHARED") && "!group-hover:text-red-500 !text-red-500"}`}
                                        >
                                            {item.title}
                                        </span>
                                    </div>
                                ))}
                        </div>
                    </Dialog>
                </>
            )}
        </section>,
        document.getElementById("context-menu-root")!
    );
}
